/* Silent product-detail loop. Other product media retain their native behaviour. */
if (!customElements.get('wsc-product-loop')) {
  customElements.define('wsc-product-loop', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video || !window.IntersectionObserver) return;
      this.visible = false;
      this.blocked = false;
      this.pending = false;
      this.video.muted = true;
      this.video.controls = false;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onPause = () => this.schedule(false);
      this.onChange = () => this.schedule(true);
      this.video.addEventListener('pause', this.onPause);
      document.addEventListener('visibilitychange', this.onChange);
      this.motion.addEventListener('change', this.onChange);
      this.observer = new IntersectionObserver((entries) => {
        this.visible = entries[entries.length - 1].intersectionRatio >= 0.25;
        this.schedule(true);
      }, { threshold: [0, 0.25] });
      this.observer.observe(this);
      this.modalObserver = new MutationObserver(this.onChange);
      document.querySelectorAll('product-modal, modal-dialog').forEach((modal) => {
        this.modalObserver.observe(modal, { attributes: true, attributeFilter: ['open'] });
      });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.modalObserver?.disconnect();
      this.video?.removeEventListener('pause', this.onPause);
      document.removeEventListener('visibilitychange', this.onChange);
      this.motion?.removeEventListener('change', this.onChange);
      this.visible = false;
      this.video?.pause();
    }

    // The existing gallery calls this after selecting a media thumbnail.
    loadContent() {
      this.schedule(true);
    }

    schedule(retry) {
      if (retry) this.blocked = false;
      if (this.queued) return;
      this.queued = true;
      queueMicrotask(() => {
        this.queued = false;
        this.sync();
      });
    }

    sync() {
      if (!this.video) return;
      const shouldPlay = this.isConnected && this.visible && !document.hidden &&
        !this.motion?.matches && !document.querySelector('product-modal[open], modal-dialog[open]');
      if (!shouldPlay) {
        if (!this.video.paused) this.video.pause();
        return;
      }
      if (this.blocked || this.pending || !this.video.paused) return;
      this.pending = true;
      Promise.resolve(this.video.play()).catch(() => {
        // Browser restrictions leave the poster intact. Never spin on a rejection.
        this.blocked = true;
      }).finally(() => {
        this.pending = false;
        if (!this.isConnected || !this.visible || document.hidden || this.motion?.matches ||
            document.querySelector('product-modal[open], modal-dialog[open]')) this.video.pause();
      });
    }
  });
}
